<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  image: props.data?.image || '',
  icon: props.data?.icon || '',
  name: props.data?.name || props.listCreateName || '',
  send_invoice_via: props.data?.send_invoice_via || '',
  accounts_payable_id: props.data?.accounts_payable_id || '',
  active: props.data?.active || true,
  uid: props.data?.uid || '',
})

setFieldRules('send_invoice_via', [required('Select how Invoice should be sent')])
setFieldRules('name', [required('Name is required')])


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const sendInvoiceViaList = [
  {id: 'Print', name: 'Print'},
  {id: 'Email', name: 'Email'},
]

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload label="Icon Image" accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml" :max-size="5" :multiple="false"
          :readonly="isReadOnly" :image="true" path="vendor_types" v-model="fields.image.value" />
      </div>
      <div class="grid md:grid-cols-3 gap-6">

        <TextInput v-model="fields.name.value" label="Name" class="col-span-2" placeholder="Enter Name" :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null" @blur="fields.name.touched = true" />

        <TextInput v-model="fields.icon.value" label="icon" placeholder="Enter icon" :readonly="isReadOnly"
          :error="fields.icon.touched ? fields.icon.error : null" @blur="fields.icon.touched = true" />

        <SearchSelect v-model="fields.send_invoice_via.value" label="Send Invoice By" :options="sendInvoiceViaList"
          :readonly="isReadOnly" :error="fields.send_invoice_via.touched ? fields.send_invoice_via.error : null"
          @blur="fields.send_invoice_via.touched = true" />

          <SearchSelect v-model="fields.accounts_payable_id.value" label="Payable Account" end-point="finance/accounting/chart-of-accounts"
          extra="Current Liabilities" :readonly="isReadOnly" :error="fields.accounts_payable_id.touched ? fields.accounts_payable_id.error : null"
          @blur="fields.accounts_payable_id.touched = true" />

        <CheckInput v-model="fields.active.value" :readonly="isReadOnly" label="Active"
          :error="fields.active.touched ? fields.active.error : null" @blur="fields.active.touched = true" />

      </div>
    </template>
  </ModalFormTemplate>
</template>